import type { ServiceAddress } from '@/lib/service/ecs/contracts';
import { COUNTRY_CALLING_CODES } from '@/lib/phonePrefixes/const';
import type { RepairRequestStoredAddress } from '@/lib/service/repairRequestState';

const ALLOWED_TITLES = new Set(['Mr', 'Mrs', 'Ms']);

export function formatRepairContactPhone(prefixCode: string, phone: string): string {
  const national = phone.replaceAll(/\s+/g, '');
  if (!national) return '';

  const entry = COUNTRY_CALLING_CODES.find((item) => item.code === prefixCode);
  if (!entry) return national;

  return `${entry.value}${national}`.replaceAll(/\s+/g, '');
}

export function mapStoredToServiceAddress(
  address: RepairRequestStoredAddress,
  email: string,
  phone: string,
  addressType: 'shipping' | 'billing'
): ServiceAddress {
  const title = address.title && ALLOWED_TITLES.has(address.title) ? address.title : null;

  return {
    addressType,
    title,
    address1: address.companyName?.trim() || '',
    address2: address.streetAddress1,
    address3: address.streetAddress2 || '',
    city: address.city,
    state: address.countryArea || '',
    country: address.country,
    email,
    firstName: address.firstName,
    lastName: address.lastName,
    mobileNumber: phone,
    phoneNumber: phone,
    zipCode: address.postalCode,
  };
}
